import { Pie, PieChart, ResponsiveContainer } from "recharts";
import { Text } from "@/elements/text/text";
import { FundWithTranches } from "@/model/db";
import { i18n } from "@/model/i18n";
import { type ReactElement } from "react";
import { Color } from "@/elements/text/types";
import { ChartLabels } from "@/components/chart_labels/chart_labels";
import { Formatter } from "@/model/formatter";
import { Stack } from "@/elements/stack/stack";

interface Props {
  assetSubclasses: FundWithTranches["assetSubclasses"];
}

const COLORS: Color[] = [
  "chart-series1",
  "chart-series2",
  "chart-series3",
  "chart-series4",
  "chart-series5",
];

const formatter = new Formatter({ locale: "de" });

export function AssetsDonut({ assetSubclasses }: Props): ReactElement {
  const mappedAssets = assetSubclasses
    .sort((a, b) => b.sharePerc - a.sharePerc)
    .map((asset, index) => ({
      ...asset,
      fill: `var(--${COLORS[index % COLORS.length]})`,
    }));

  return (
    <div className="assets-donut">
      <Stack size={40} tabletSize={60} desktopSize={80}>
        <Stack size={40} desktopSize={60}>
          <Text
            type="h3-xbold"
            color="primary-on-default"
            htmlElement="h3"
            uppercase
          >
            {i18n.t("components.assets_donut.asset_classes")}
          </Text>
          <ResponsiveContainer width="100%" height={328}>
            <PieChart>
              <Pie
                data={mappedAssets}
                dataKey="sharePerc"
                cx="50%"
                cy="50%"
                innerRadius={120}
                outerRadius={160}
                stroke=""
              />
            </PieChart>
          </ResponsiveContainer>
        </Stack>
        <ChartLabels
          labels={mappedAssets.map((item) => ({
            text: item.assetSubclassName,
            value: formatter.percentage(item.sharePerc),
            color: item.fill,
          }))}
        />
      </Stack>
    </div>
  );
}
